<template>
  <div class="simple-input-group">
    <label :for="name">{{ t(`labels.${props.label ?? props.name}`) }}</label>
    <InputText
      :id="name"
      v-model="internalValue"
      :disabled="disabled"
      :readonly="readonly"
      :type="type"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  name: string;
  modelValue: string | number | undefined;
  type?: 'text' | 'number' | 'email' | 'password';
  label?: string;
  disabled?: boolean;
  readonly?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number | undefined): void;
}>();

const internalValue = computed({
  get: () => String(props.modelValue ?? ''),
  set: (val: string) => {
    if (props.type === 'number') {
      const num = parseFloat(val);
      emit('update:modelValue', isNaN(num) ? undefined : num);
    } else {
      emit('update:modelValue', val);
    }
  },
});

const { t } = useI18n();
</script>
